import { useMemo, type CSSProperties } from "react";
import { subtitleAt } from "@heroncendre/core";
import { selectGuideTrack, useGuided, useTourState } from "@heroncendre/player";
import { CREME, POLICE_UI_SPLASH } from "./guideStyles.js";

/**
 * Le sous-titre de l'instant, lu dans la piste du chapitre (`tracks.<langue>.subtitles`,
 * inline dans le document — pas de fichier WebVTT). `aria-live` : un lecteur d'écran
 * annonce chaque phrase. Éteint (CC), le conteneur RESTE : sa place est réservée, la
 * bande ne saute pas quand on bascule.
 */
export function GuideSubtitles({ actif, style }: { actif: boolean; style?: CSSProperties }) {
  const { pilot } = useGuided();
  const tour = useTourState((s) => s.tour);
  const language = useTourState((s) => s.context.language);
  const indexChapitre = useTourState((s) => s.guided.stepIndex);
  const temps = useTourState((s) => s.narration.time);

  const piste = useMemo(
    () => selectGuideTrack(tour, pilot.guideIdAt(indexChapitre), language)?.track,
    [tour, pilot, indexChapitre, language],
  );
  const phrase = actif && piste ? subtitleAt(piste.subtitles, temps) : null;

  return (
    <div
      aria-live="polite"
      style={{
        fontFamily: POLICE_UI_SPLASH,
        color: "#F1E9DC",
        textAlign: "center",
        textWrap: "balance",
        lineHeight: 1.35,
        ...style,
      }}
    >
      {phrase?.text ?? ""}
    </div>
  );
}

export const FOND_SOUSTITRES: CSSProperties = {
  background: "rgba(11,19,16,.74)",
  color: CREME,
  borderRadius: 2,
  padding: "6px 14px",
};
